import cloneDeep from 'lodash/cloneDeep';
import { StatePreV8, StateV8 } from './8_migrate_vorschaeden.interface';

export const migrateVorschaeden = (previousState: StatePreV8, newVersion: number): StateV8 => {
  const newState = cloneDeep(previousState);
  const feuerCount = newState.vorschaeden.feuer;
  const elementarCount = newState.vorschaeden.elementar;
  const leistungswasserCount = newState.vorschaeden.leitungswasser;
  const sturmhagelCount = newState.vorschaeden.sturmhagel;
  delete newState.vorschaeden.feuer;
  delete newState.vorschaeden.elementar;
  delete newState.vorschaeden.leitungswasser;
  delete newState.vorschaeden.sturmhagel;
  return {
    ...newState,
    version: newVersion,
    vorschaeden: {
      ...newState.vorschaeden,
      feuerVorschaden: {
        count: feuerCount,
        includeInDruck: true,
        includeInEinreichen: true,
        includeInTarifierung: true,
        visibleInErsatzgeschaeft: false,
      },
      elementarVorschaden: {
        count: elementarCount,
        includeInDruck: true,
        includeInEinreichen: true,
        includeInTarifierung: true,
        visibleInErsatzgeschaeft: false,
      },
      leitungswasserVorschaden: {
        count: leistungswasserCount,
        includeInDruck: true,
        includeInEinreichen: true,
        includeInTarifierung: true,
        visibleInErsatzgeschaeft: false,
      },
      sturmhagelVorschaden: {
        count: sturmhagelCount,
        includeInDruck: true,
        includeInEinreichen: true,
        includeInTarifierung: true,
        visibleInErsatzgeschaeft: false,
      },
    },
  };
};
